module.exports = __webpack_public_path__ + "img/type2_default.7047c142.png";